import axios from 'axios';

export const ENGINE_UPGRADE_REQUEST = 'Please upgrade the engine version';

export function isEngineUpgradeRequiredError(err: unknown): boolean {
  return (
    axios.isAxiosError(err) &&
    err.response?.status === 409 &&
    (err.response.data as { error?: string } | undefined)?.error === 'engine_upgrade_required'
  );
}
